import React, { useState } from "react";
import "./RecPass.css";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const RecPass = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const auth = getAuth();
  const [errorMessage, setErrorMessage] = useState("");

  const handleRec = async () => {
    try {
      sendPasswordResetEmail(auth, email).then(() => {
        alert("Se ha enviado un correo para reestablecer la contraseña.");
        navigate("/login");
      });
    } catch (error) {
      setErrorMessage("El correo no se encuentra registrado.");
    }
  };

  return (
    <div className="container margin-login">
      <div className="row justify-content-center">
        <div className="col-lg-4 col-md-6 col-sm-8">
          <h2 className="text-center">Recuperacion de contraseña</h2>
          <form className="container-auth">
            <div className="form-group">
              <label htmlFor="email"></label>
              <input
                name="email"
                type="email"
                placeholder="E-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            {errorMessage ? (
              <>
                <br />
                {errorMessage}
              </>
            ) : (
              <></>
            )}
            <br />
            <div className="container-buttons">
              <button type="button" onClick={handleRec}>
                Envias correo.
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RecPass;
